module.exports = __webpack_public_path__ + "static/media/phone-1@2x.24e4fa17.png";